// ABOUTME: Reusable section component for structured tooltip content
// ABOUTME: Displays title with optional color and children content

import { memo, type ReactNode } from "react"

interface TooltipSectionProps {
  title?: string
  titleColor?: string
  className?: string
  children: ReactNode
}

export const TooltipSection = memo(
  ({ title, titleColor = "text-gray-400", className = "", children }: TooltipSectionProps) => {
    return (
      <div className={`mb-2 last:mb-0 ${className}`}>
        {title && <div className={`text-[11px] font-medium mb-1 ${titleColor}`}>{title}</div>}
        <div className="text-[12px] leading-[16px] whitespace-normal">{children}</div>
      </div>
    )
  },
)

TooltipSection.displayName = "TooltipSection"
